import React, { useEffect } from "react";

const ExportExcel = (props) => {

    useEffect(() => {
        console.log('jsonObject', props.jsonObject);
    }, [props.jsonObject]);

    const exportJSON = () => {

        // var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        var array = props.jsonObject;
        console.log('array', array);

        var str = '';

        for (var i = 0; i < array.length; i++) {
            var line = '';

            for (var index in array[i]) {
                if (array[i][index].export) {
                    line += array[i][index].export + ',';
                } else {
                    line += "" + ',';
                }


            }

            // Here is an example where you would wrap the values in double quotes
            // for (var index in array[i]) {
            //    line += '"' + array[i][index] + '",';
            // }

            line.slice(0, line.Length - 1);

            str += line + '\r\n';
        }
        window.open("data:text/csv;charset=utf-8," + escape(str));



    };

    return (
        <div className="export-excel">
            <button className="btn btn-secondary btn-sm"
                onClick={exportJSON}>
                <i className="fa fa-download me-2" />
                Export to Excel
            </button>
        </div>
    );
};

export default ExportExcel;